import request from '@/utils/request'
import da from "element-ui/src/locale/lang/da";


export function getCalenderList(data) {
  return request({
    url: '/calender/getcalenderlist',
    method: 'get',
    params:data
  })
}
